import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ApproachPage from "@/pages/ApproachPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import ApplyPage from "@/pages/ApplyPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminApplicationsPage from "@/pages/AdminApplicationsPage";
import AuthCallback from "@/components/admin/AuthCallback";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

function AppRouter() {
    const location = useLocation();

    // CRITICAL: synchronously detect Emergent's `#session_id=...` callback fragment
    // during render — useEffect would run AFTER ProtectedRoute first renders,
    // causing a race that bounces the user to /admin/login.
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }

    return (
        <Routes>
            {/* Admin auth pages — outside the public site Layout */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
                path="/admin/applications"
                element={
                    <ProtectedRoute>
                        {(user) => <AdminApplicationsPage user={user} />}
                    </ProtectedRoute>
                }
            />

            {/* Public site */}
            <Route element={<Layout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/approach" element={<ApproachPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/apply" element={<ApplyPage />} />
                <Route path="*" element={<HomePage />} />
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppRouter />
        </BrowserRouter>
    );
}

export default App;
